'use client'
import { Image } from '@/types/common/ImageData'
import s from './Related.module.scss'
import { Fragment } from 'react'
import Link from 'next/link'
import LazyImage from '@/components/common/LazyImage'
import { Category, Typology } from '@/types/singles/category'
import ProjectFeaturedComponent from '@/components/singles/projectFeatured'
import JournalFeaturedComponent from '@/components/singles/journalFeatured'
import { createRelatedContentSchemas } from '@/lib/constants'
import { LinkExternal } from '@/types/common/LinkExternal'

interface RelatedProps {
    data: DataProps
}

interface ImageProp {
    image: Image;
    imageMobile: Image | null;
}

interface JournalsProps {
    slug: string;
    title: string;
    featuredImage: ImageProp | null;
    featuredImageHover: ImageProp | null;
    subtitle: string | null;
    categories: Array<Category>;
    writtenBy: string | null;
    secondTitle: string | null;
    isExternal: boolean;
    externalUrl?: LinkExternal | null;
}

interface ProjectsProps {
    slug: string;
    title: string;
    featuredImage: ImageProp | null;
    featuredImageHover: ImageProp | null;

    location: string | null;
    typologies: Array<Typology>;
}

interface DataProps {
    _type: string;
    _ref: string;
    title: string | null;
    option: string | null;
    columns: string | null;
    backgroundColor: any | null;
    projects: Array<ProjectsProps> | null;
    chronicles: Array<JournalsProps> | null;
}

export default function RelatedComponent({
    data
}: RelatedProps) {
    const relatedContentSchema1 = createRelatedContentSchemas(data.projects || [], "projects", "CreativeWork");
    const relatedContentSchema2 = createRelatedContentSchemas(data.chronicles || [], "journal", "BlogPosting");


    return (
        <div className={s.related} style={data.backgroundColor ? { backgroundColor: data.backgroundColor.hex } : undefined}>
            {data.title && <p className={s.title}>{data.title}</p>}
            {data.columns == 'full' ?
                <>
                    {data.option == 'project' && data.projects && data.projects.filter(Boolean).map((item: ProjectsProps, index: number) => {

                        return (
                            <Link href={`/projects/${item.slug}`} key={`index-${index}-full-related`}>
                                <div className={s.full} key={`index-${index}-full-related`}>
                                    <div className={s.fullImage}>
                                        {item.featuredImage && item.featuredImage.image &&
                                            <LazyImage
                                                src={item.featuredImage.image.imageUrl}
                                                width={0}
                                                height={0}
                                                blurDataURL={item.featuredImage.image.ref}
                                                fill
                                                alt={item.featuredImage.image.attribution || ""}
                                                caption={item.featuredImage.image.caption || null}
                                                filename={item.featuredImage.image.filename || ""}
                                            />}
                                    </div>
                                    <div className={s.fullContent}>
                                        <div className={s.fullText}>

                                            <h2 className={'h1'}>{item.title}</h2>
                                            <div>
                                                {item.location && <p className={'h1'}>{item.location}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                    {data.option == 'journal' && data.chronicles && data.chronicles.filter(Boolean).map((item: JournalsProps, index: number) => {
                        return (
                            <Link href={`/journal/${item.slug}`} key={`index-${index}-full-related`}>
                                <div className={s.fullJournal} key={`index-${index}-full-related`}>
                                    <div className={s.fullImage}>
                                        {item.featuredImage && item.featuredImage.image &&
                                            <LazyImage
                                                src={item.featuredImage.image.imageUrl}
                                                width={0}
                                                height={0}
                                                blurDataURL={item.featuredImage.image.ref}
                                                fill
                                                alt={item.featuredImage.image.attribution || ""}
                                                caption={item.featuredImage.image.caption || null}
                                                filename={item.featuredImage.image.filename || ""}
                                            />}
                                    </div>
                                    <div className={s.fullContent}>
                                        <div className={s.fullText}>

                                            <h2 className={'h1'}>{item.title}{item.secondTitle && <>: <br></br>{item.secondTitle}</>}</h2>
                                            <div>
                                                {item.subtitle && <p className={'h1'}>{item.subtitle}</p>}
                                                {item.writtenBy && <p className={s.author}><span>Written By</span> <span>{item.writtenBy}</span></p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        )
                    })}
                </> :

                <div className={`${s.list} ${data.columns == '1' ? s.one : data.columns == '2' ? s.two : data.columns == '3' ? s.three : s.four}`}>

                    {data.option == 'project' && data.projects && data.projects.filter(Boolean).map((item: ProjectsProps, index: number) => {
                        return (
                            <Fragment key={`index-${index}-related`}>
                                <ProjectFeaturedComponent data={item} />
                            </Fragment>
                        )
                    })}

                    {data.option == 'journal' && data.chronicles && data.chronicles.filter(Boolean).map((item: JournalsProps, index: number) => {
                        return (
                            <Fragment key={`index-${index}-related`}>
                                <JournalFeaturedComponent data={item} />
                            </Fragment>
                        )
                    })}
                </div>
            }
            <script type="application/ld+json" async dangerouslySetInnerHTML={{ __html: JSON.stringify(relatedContentSchema1) }} />
            <script type="application/ld+json" async dangerouslySetInnerHTML={{ __html: JSON.stringify(relatedContentSchema2) }} />
        </div>
    )
}
